import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';
import IdleTimer from 'react-idle-timer';

ReactDOM.render(
	<React.StrictMode>
		<IdleTimer>
			<App />
		</IdleTimer>
	</React.StrictMode>,
	document.getElementById('root')
);
